@if (isOpen) {
  <div
    class="modal fade show d-block"
    tabindex="-1"
    role="dialog"
    aria-modal="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">

        <!-- Header -->
        <div class="modal-header">
          <h5 class="modal-title">
            Rate this translation
          </h5>

          <button
            type="button"
            class="btn-close"
            aria-label="Close"
            (click)="close()"
          ></button>
        </div>

        <!-- Body -->
        <div class="modal-body">

          <!-- Rating -->
          <div class="text-center mb-4">

            <div class="d-flex justify-content-center gap-2">
              @for (star of ratings; track star) {
                <button
                  type="button"
                  class="btn btn-link p-0 text-decoration-none"
                  [attr.aria-label]="'Rate ' + star + ' out of 5'"
                  (click)="selectRating(star)"
                >
                  <span
                    class="fs-2"
                    [class.text-warning]="star <= rating"
                    [class.text-secondary]="star > rating"
                  >
                    ★
                  </span>
                </button>
              }
            </div>

            @if (rating) {
              <div class="small text-muted mt-1">
                {{ rating }} / 5
              </div>
            }
          </div>

          <!-- Comment -->
          <div class="mb-3">
            <label
              for="languageFeedbackComment"
              class="form-label"
            >
              Feedback
            </label>

        <app-textarea-input
  inputId="languageFeedbackComment"
  label="Comment"
  [control]="comment"
  [rows]="4"
  [maxLength]="2000"
  placeholder="Describe your issue or feedback"
>
</app-textarea-input>
          </div>

        </div>

        <!-- Footer -->
        <div class="modal-footer">

          <button
            type="button"
            class="btn btn-secondary"
            (click)="close()"
          >
            Cancel
          </button>

          <button
            type="button"
            class="btn btn-primary"
            [disabled]="!rating"
            (click)="submit()"
          >
            Submit
          </button>

        </div>

      </div>
    </div>
  </div>

  <!-- Bootstrap modal backdrop -->
  <div
    class="modal-backdrop fade show"
    (click)="close()"
  ></div>
}